import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_FULFILLMENT_SETTINGS = `${URL_RETAILER_SCOPED}/fulfillment-settings`
const URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES = `${URL_FULFILLMENT_SETTINGS}/order-orchestration`
const URL_FULFILLMENT_SETTINGS_CREATE_FULFILLMENT_RULE = `${URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES}/create`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'fulfillment-settings'>
  | DashRouteType<'fulfillment-settings-list-fulfillment-rules'>
  | DashRouteType<'fulfillment-settings-create-fulfillment-rule'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'fulfillment-settings': URL_FULFILLMENT_SETTINGS,
  'fulfillment-settings-list-fulfillment-rules': URL_FULFILLMENT_SETTINGS_LIST_FULFILLMENT_RULES,
  'fulfillment-settings-create-fulfillment-rule': URL_FULFILLMENT_SETTINGS_CREATE_FULFILLMENT_RULE,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
